import { useCallback } from 'react';

import { httpMethods, IHeader, IHttpHookResponseAwaitable, useHttpClientAwaitable } from '@services/httpClientService';

import { ApiSectionNamespace } from '../../../apiConstants';

import { mappingFunction } from './mapper';
import { IPaypalOaltInitiate, IPaypalOaltInitiateRequest, IPaypalOaltInitiateApiResponse } from './model';

export const usePaypalOaltInitiateOnDemand = (
  paymentId?: number,
): IHttpHookResponseAwaitable<IPaypalOaltInitiate, IPaypalOaltInitiateRequest> => {
  const customHeaders: IHeader[] = paymentId ? [{ 'X-Payment': paymentId.toString() }] : [];

  const { request: asyncRequest } = useHttpClientAwaitable<
    IPaypalOaltInitiate,
    IPaypalOaltInitiateRequest,
    IPaypalOaltInitiateApiResponse
  >({
    method: httpMethods.POST,
    path: ApiSectionNamespace.EPaymentApiKeys.PAYMENT_PAYPAL_INITIATE_OALT,
    mappingFunction: mappingFunction,
    customHeaders,
  });

  const request = useCallback(
    (params?: IPaypalOaltInitiateRequest) => {
      return asyncRequest(params && { data: { ...params } });
    },
    [asyncRequest],
  );

  return { request };
};
